import React from "react";
import "../styles/EnrolmentsSection.css";

/**
 * EnrolmentSection
 *
 * Layout requirements:
 * - Desktop: two full-width columns across the viewport
 * - Mobile: stack columns (text then image)
 * - Image fills 100% width of its column
 * - Button text should not wrap on mobile
 */
const EnrolmentSection = ({
  title = "ENROLMENT",
  headline = "Join a school that meets you where you are.",
  description = `The Avenue School welcomes students who need a more supportive and flexible learning environment. Our enrolment process is designed to understand each student’s needs from the start—ensuring wellbeing, privacy, and a smooth transition into our community.`,
  image = "/media/welcome-space.png",
}) => {
  return (
    <section className="enroll-section" aria-labelledby="enrolment-heading">
      <div className="enroll-content">
        <h3 className="enroll-title">{title}</h3>
        <h2 id="enrolment-heading" className="enroll-headline">
          {headline}
        </h2>
        <p className="enroll-desc">{description}</p>

        <div className="enroll-buttons">
          <a href="/enrolments" className="btn-primary">
            Get started
          </a>
          <a href="/contact" className="btn-secondary">
            Contact Us
          </a>
        </div>
      </div>

      <div className="enroll-image">
        <img src={image} alt="Students learning together" />
      </div>
    </section>
  );
};

export default EnrolmentSection;

